import dropdownService from '@/services/dropdownService';
import OnloadData from '@/mocks/data/activeProjectsService/onload.json';

// Transform Onload.json data to consistent format
const transformOnloadData = (data: any) => {
  const transformed: Record<string, Array<{id: string | number, label: string, value: string}>> = {};
  
  Object.entries(data).forEach(([key, values]: [string, any]) => {
    transformed[key] = values.map((item: any, index: number) => ({
      id: item.id || index + 1,
      // For user objects with firstname, use firstname as label; otherwise use id
      label: item.label || item.firstname || item.id || item.value, 
      value: item.value             // Use value as form value
    }));
  });
  
  return transformed;
};

// Configure Active Projects module
export const setupActiveProjectsDropdowns = () => {
  dropdownService.register({
    'active-projects': {
      module: 'active-projects',
      dataSource: 'json',
      source: '@/mocks/data/activeProjectsService/onload.json',
      transform: transformOnloadData
    }
  });
};

// Direct access for Active Projects dropdowns (without service overhead)
export const getActiveProjectsDropdowns = (categories?: string[]) => {
  const allData = transformOnloadData(OnloadData);
  
  if (categories && categories.length > 0) {
    const filtered: Record<string, any> = {};
    categories.forEach(cat => {
      filtered[cat] = allData[cat] || [];
    });
    return filtered;
  }
  
  return allData;
};

// Available dropdown categories for Active Projects
export const ACTIVE_PROJECTS_DROPDOWN_CATEGORIES = [
  'country',
  'vendor', 
  'fda_usda',
  'edi',
  'logistic',
  'business_status',
  'productSpecificationType',
  'packagetype',
  'sellingPeriod',
  'productType',
  'keyAttributesRequired',
  'retail',
  'panelType',
  'label',
  'panelLocation',
  'status',
  'ada',
  'category',
  'categoryManager',
  'buyer',
  'qaComplianceManager',
  'productCreator',
  'nutritionist',
  'warehouses'
] as const;

export type ActiveProjectsDropdownCategory = typeof ACTIVE_PROJECTS_DROPDOWN_CATEGORIES[number];

// Test the data transformation (debug) - run only once
if (process.env.NODE_ENV === 'development') {
  console.log('🔍 Testing direct data access...');
  console.log('🔍 OnloadData keys:', Object.keys(OnloadData));
  console.log('🔍 Direct productSpecificationType:', OnloadData.productSpecificationType);
  console.log('🔍 Direct fda_usda:', OnloadData.fda_usda);
  console.log('🔍 Raw categoryManager data:', OnloadData.categoryManager);
  console.log('🔍 Transformed categoryManager:', transformOnloadData(OnloadData).categoryManager);
}

// Initialize the configuration
setupActiveProjectsDropdowns();
